import { useHistory } from "react-router-dom";
import { Page, Container, Grid, Box } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useState, useEffect } from "react";
import { Header } from "../../components";
import { config } from "../../configs";
import { QuickActions } from "./QuickActions";
import { RecentWorks } from "./RecentWork";
import { UpcomingWork } from "./UpcomingWork";
import { useSelector } from "react-redux";
import { getOrgWorkEvents, getUserProfileData } from "../../services";

Auth.configure(config);

export const Home = () => {
  let history = useHistory();
  const [userName, setUserName] = useState("");
  const [workEvents, setWorkEvents] = useState([]);

  const currentOrg = useSelector(
    (state) => state.organization?.currentOrganization
  );
  let appRole = currentOrg?.app_role;
  let doesUserHavePermission = appRole === "ADMIN" || appRole === "SUPERVISOR";

  useEffect(() => {
    async function fetchData() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        window?.localStorage.setItem(
          "IS_PLATFORM_ADMIN",
          user?.attributes["custom:plat_admin"]
            ? user?.attributes["custom:plat_admin"]
            : ""
        );
        const { data } = await getUserProfileData();
        let name =
          data?.display_name?.trim() ||
          data?.first_name?.trim() ||
          data?.username?.trim();
        setUserName(name);
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    const getAllWorkEvents = async () => {
      try {
        if (currentOrg?.id !== null || currentOrg?.id !== undefined) {
          let workEvents = await getOrgWorkEvents(currentOrg?.id);
          setWorkEvents(workEvents);
        }
      } catch (error) {}
    };

    getAllWorkEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg]);

  return (
    <Page title="FlukeWorks">
      <Header home xl name={userName && `Hi, ${userName}!`} history={history} />
      <Container maxWidth="xl">
        <Box sx={{ flexGrow: 1, mb: 5 }}>
          <Grid container spacing={6} style={{ width: "100%" }}>
            <Grid item xs>
              <UpcomingWork workEvents={workEvents} orgId={currentOrg?.id} />
            </Grid>
            <Grid item xs>
              <RecentWorks workEvents={workEvents} orgId={currentOrg?.id} />
            </Grid>
            {doesUserHavePermission ? (
              <Grid item xs>
                <QuickActions orgId={currentOrg?.id} />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Box>
      </Container>
    </Page>
  );
};

export const listTextColor = {
  color: "#2b7cd3",
};
